<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
      v-on:error="errorHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import WorkScheduleStaffForm from "../../../components/attendance/workschedulestaff/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": WorkScheduleStaffForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('workschedulebystaffprocess.createnewworkschedulebystaffforaperiod'),
      pageTitleValue: "",
      formData: {
        psnid: null,
        staffid: null,
        compnyid: null,
        startdate: null,
        enddate: null,
        shiftid: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }

      this.$store.dispatch('post', {url: "/workschedulestaff/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "workschedulestafflist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
           console.log("err", err);
        });
    },

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    cancelHandler() {
      this.$router.push({ name: "workschedulestafflist" });
    },
  },
};
</script>